import support from '@/components/support/support/support.vue';
import helpAndSupport from '@/components/support/help-and-support/help-and-support.vue';
import learnTheBasics from '@/components/support/learn-the-basics/learn-the-basics.vue';
import communityForums from '@/components/support/community-forums/community-forums.vue';
import faq from '@/components/support/faq/faq.vue';
import whatIsPredictIt from '@/components/support/what-is-predictit/what-is-predictit.vue';
import videos from '@/components/support/videos/videos.vue';

export default [

  {
    path: '/support',
    component: support,
    props: true,
    children: [
      {
        path: '',
        name: 'HelpAndSupport',
        component: helpAndSupport,
        props: true,
      },
      {
        path: 'what-is-predictit',
        name: 'WhatIsPredictIt',
        component: whatIsPredictIt,
        props: true,
      },
      {
        path: 'how-to-trade-on-predictit',
        name: 'LearnTheBasics',
        component: learnTheBasics,
        props: true,
      },
      {
        path: 'community-forums',
        name: 'ComunityForums',
        component: communityForums,
        props: true,
      },
      {
        path: 'faq',
        name: 'Faq',
        component: faq,
        props: true,
      },
      {
        path: 'videos',
        name: 'Videos',
        component: videos,
        props: true,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/support.js